import {
  LightAsync as SyntaxHighlighter,
  SyntaxHighlighterProps,
} from "react-syntax-highlighter";
import { atomOneLight as codeStyle } from "react-syntax-highlighter/dist/cjs/styles/hljs";

export interface CodeViewerProps extends Omit<
  SyntaxHighlighterProps,
  "showLineNumbers"
> {
  language: string;
  noNumbers?: boolean | undefined;
  children: string;
}

export default function CodeViewer({
  language,
  noNumbers,
  children,
  className = "rounded-md",
  wrapLines = true,
  wrapLongLines = true,
  ...props
}: CodeViewerProps) {
  return (
    <SyntaxHighlighter
      PreTag="pre"
      children={children.replace(/\n$/, "")}
      language={language}
      className={className}
      style={codeStyle}
      showLineNumbers={!noNumbers}
      wrapLines={wrapLines}
      wrapLongLines={wrapLongLines}
      {...props}
    />
  );
}
